import React from 'react';
import { Tab, Responsive } from 'semantic-ui-react';
// import PreviousCertificates from './PreviousCertificates';
import NewExternalStudentCertificate from './NewExternalStudentCertificate';
import PreviousExternalStudentCertificates from './PreviousExternalStudentCertificates';


export default class ExternalStudentCertificates extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        const activeRole = localStorage.getItem('activeRole') || '';
        const canIssueDocuments = activeRole.substr(0, 10) === 'Studentska';

        const panes = [
            canIssueDocuments ? {
                menuItem: 'Izdavanje dokumenata',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <NewExternalStudentCertificate student={this.props.student} />

                </Tab.Pane>)
            } : null,
            {
                menuItem: 'Izdati dokumenti',
                render: () => (<Tab.Pane attached={false} as={Responsive} >
                    <PreviousExternalStudentCertificates
                        externalStudentId={this.props.student.id}
                    />
                </Tab.Pane>)
            }

        ];


        return (
            <div>
                <Tab
                    panes={panes}
                    menu={{
                        secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                    }}
                    defaultActiveIndex={canIssueDocuments ? 0 : 1}
                    grid={{ paneWidth: 13, tabWidth: 3 }}
                />
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/ExternalStudentCertificates.js